<template>
  <div>
    <div>
      <div class="datepickerwrap card tw-border-0">
        <div class="tw-flex tw-justify-between tw-items-center">
          <div id="vendorDateRange" class="tw-flex tw-gap-6">
            <div>
              <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-[9px] tw-mx-1">
                Date
              </div>
              <date-range-picker
                v-model="dateRange"
                :show-dropdowns="true"
                opens="right"
                :autoApply="true"
                :single-date-picker="true"
                :locale-data="{ format: 'dd mmm yyyy' }"
                :max-date="maxDate"
                @update="getTableData"
              >
              </date-range-picker>
            </div>
            <div>
              <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-2 tw-mx-1">
                Warehouse
              </div>
              <multiselect
                v-model="selectedWarehouse"
                :options="warehouseList"
                :multiple="false"
                :searchable="true"
                placeholder="Select Warehouse"
                label="warehouse_name"
                track-by="warehouse_name"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="tw-w-[215px]"
                @select="getTableData"
              >
                <template #singleLabel="{ option }">
                  <div
                    class="tw-truncate tw-whitespace-nowrap tw-overflow-hidden tw-w-[180px]"
                  >
                    {{ option.warehouse_name }}
                  </div>
                </template>
              </multiselect>
            </div>
            <!-- <div>
              <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-2 tw-mx-1">
                Channel
              </div>
              <multiselect
                v-model="selectedSKU"
                :options="skuList"
                :multiple="false"
                :searchable="true"
                placeholder="Select Channel"
                label="product_sku"
                track-by="product_sku"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="tw-w-[215px]"
              >
              </multiselect>
            </div> -->
            <div>
              <div class="tw-text-[#050A13] tw-text-[14px] tw-mb-2 tw-mx-1">
                SKU
              </div>
              <multiselect
                v-model="selectedSKU"
                :options="skuList"
                :multiple="false"
                :searchable="true"
                placeholder="Enter SKU ID"
                label="product_sku"
                track-by="product_sku"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="tw-w-[215px]"
                @select="getTableData"
              >
                <template #singleLabel="{ option }">
                  <div
                    class="tw-truncate tw-whitespace-nowrap tw-overflow-hidden tw-w-[180px]"
                  >
                    {{ option.product_sku }}
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
          <div>
            <b-button
              v-if="!isCreateForm && isDataPresent"
              @click="handleCreateForm"
              class="btn primarycolor"
              >Create Form</b-button
            >
            <b-button
              v-if="isCreateForm"
              @click="handleBack"
              class="btn primarycolor"
              >Back</b-button
            >
          </div>
        </div>
      </div>
      <div v-if="tableDataLoader">
        <Loader />
      </div>
      <div v-else>
        <div
          v-if="!isDataPresent || isCreateForm"
          class="tw-flex tw-gap-4 tw-mx-2"
        >
          <div class="card tw-border-0 tw-w-[40%]">
            <div
              class="tw-text-[#065559] tw-text-[16px] tw-border-b-[1px] tw-border-[#d5d5d5] tw-pb-4 tw-mb-4"
            >
              Select Form
            </div>
            <div class="tw-flex tw-gap-4">
              <div
                v-for="(form, index) in formData"
                :key="index"
                @click="setActiveTab(index)"
                :class="[
                  'tw-w-[325px] tw-border-[1px] tw-border-[#aeaeae] tw-rounded-[5px] tw-p-4 tw-cursor-pointer',
                  activeTab === index ? 'tw-bg-[#065559]' : 'tw-bg-white',
                ]"
              >
                <img
                  :src="activeTab === index ? form.activeImage : form.image"
                />
                <div
                  :class="[
                    ' tw-text-[14px] tw-my-3',
                    activeTab === index
                      ? 'tw-text-[#fff]'
                      : 'tw-text-[#050A13]',
                  ]"
                >
                  {{ form.title }}
                </div>
                <div
                  :class="[
                    ' tw-text-[12px] tw-font-[600] tw-mb-2',
                    activeTab === index
                      ? 'tw-text-[#fff]'
                      : 'tw-text-[#505050]',
                  ]"
                >
                  {{ form.heading }}
                </div>
                <div
                  :class="[
                    ' tw-text-[12px]',
                    activeTab === index
                      ? 'tw-text-[#fff]'
                      : 'tw-text-[#505050]',
                  ]"
                >
                  {{ form.description }}
                </div>
              </div>
            </div>
          </div>
          <div class="card tw-border-0 tw-w-[60%]">
            <div class="stepper-container">
              <div class="tw-w-[60%] tw-m-auto tw-mb-[50px]">
                <div class="steps">
                  <div :class="['step', step === 1 ? 'active' : '']">
                    <span :class="['step-circle', step === 1 ? 'active' : '']"
                      >1</span
                    >&nbsp;&nbsp;SKU ID
                  </div>
                  <div class="line"></div>
                  <div :class="['step', step === 2 ? 'active' : '']">
                    <span :class="['step-circle', step === 2 ? 'active' : '']"
                      >2</span
                    >&nbsp;&nbsp;Quantity Selection
                  </div>
                  <div class="line"></div>
                  <div :class="['step', step === 3 ? 'active' : '']">
                    <span :class="['step-circle', step === 3 ? 'active' : '']"
                      >3</span
                    >&nbsp;&nbsp;Confirmation
                  </div>
                </div>
              </div>
              <div class="tw-w-[85%] tw-m-auto">
                <div v-if="step === 1" class="form-step">
                  <div class="tw-mb-3">SKU ID</div>
                  <multiselect
                    v-model="skuInput"
                    :options="skuList"
                    :multiple="false"
                    :searchable="true"
                    placeholder="Enter SKU ID"
                    label="product_sku"
                    track-by="product_sku"
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                  >
                  </multiselect>
                  <div
                    v-if="suggestions.length"
                    class="tw-text-[#505050] tw-text-[12px] tw-my-3 tw-font-[500]"
                  >
                    Suggestions
                  </div>
                  <div class="suggestions">
                    <button
                      v-for="(sku, index) in suggestions"
                      :key="index"
                      class="sku-pill focus:tw-shadow-none focus:tw-border-[#AEAEAE]"
                      @click="selectSuggestion(sku)"
                    >
                      {{ sku.product_sku }}
                    </button>
                  </div>
                  <div class="button-group tw-mt-4">
                    <button
                      v-if="step != 1"
                      @click="backStep"
                      class="navigationButton"
                    >
                      Back
                    </button>
                    <button
                      :disabled="!skuInput"
                      @click="nextStep"
                      class="btn primarycolor tw-mx-2"
                    >
                      Next
                    </button>
                  </div>
                </div>

                <div v-if="step === 2" class="form-step">
                  <div class="tw-mb-3">SKU ID</div>
                  <multiselect
                    v-model="skuInput"
                    :options="skuList"
                    :multiple="false"
                    :searchable="true"
                    placeholder="Enter SKU ID"
                    label="product_sku"
                    track-by="product_sku"
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    disabled
                  >
                  </multiselect>
                  <label for="Quantity" class="tw-my-3">Quantity</label>
                  <input
                    v-model="selecetdQuantity"
                    id="Quantity"
                    type="number"
                    placeholder="Enter Quantity"
                    class="input-box tw-shadow-none tw-border-[#AEAEAE] focus:tw-border-[#AEAEAE] tw-rounded-[5px]"
                  />
                  <!-- <div class="tw-text-[#505050] tw-text-[12px] tw-my-3 tw-font-[500]">
              Suggestions
            </div> -->
                  <!-- <div class="suggestions">
              <button
                v-for="(quantity, index) in quantitySuggestions"
                :key="index"
                class="sku-pill focus:tw-shadow-none focus:tw-border-[#AEAEAE]"
                @click="selectQuantitySuggestion(quantity)"
              >
                {{ quantity }}
              </button>
            </div> -->
                  <span class="tw-text-[#050A13] tw-mr-6 tw-text-[14px]"
                    >Have More Products?</span
                  >
                  <span
                    class="tw-text-[#065559] tw-underline tw-cursor-pointer"
                    @click="handleDownloadTemplate"
                    >Download Template</span
                  >
                  <div
                    class="upload-container tw-mt-3"
                    @dragover.prevent
                    @drop.prevent="handleDrop"
                    @click="$refs.fileInput.click()"
                  >
                    <input
                      type="file"
                      ref="fileInput"
                      style="display: none"
                      @change="handleFileSelect"
                      accept=".xls,.xlsx"
                    />
                    <div class="upload-content">
                      <img
                        src="Inventory_svg/upload.svg"
                        alt="Upload"
                        width="32"
                        class="tw-mx-auto"
                      />
                      <p class="tw-text-[#505050]">
                        <span
                          class="tw-text-[#065559] tw-underline tw-text-[14px] tw-mr-1 tw-cursor-pointer"
                          >Click to Upload</span
                        >
                        or Drag and drop
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="fileName?.name"
                    class="tw-flex tw-justify-between tw-items-center tw-px-8 tw-py-6 tw-my-4 tw-border-[1px] tw-border-[#065559] tw-rounded-[5px] tw-h-[100px] tw-gap-4"
                  >
                    <div class="tw-flex tw-items-center tw-gap-4">
                      <img
                        src="Inventory_svg/upload_successfully.svg"
                        alt="Upload"
                      />
                      <div>
                        <div class="tw-text-[#000000] tw-font-[600]">
                          {{ fileName?.name }}
                        </div>
                        <div>{{ fileSizeInKB }}</div>
                      </div>
                    </div>
                    <img
                      src="Icons_SVG/cross.svg"
                      alt="Upload"
                      class="tw-cursor-pointer tw-w-4"
                      @click="handleRemoveFile"
                    />
                  </div>
                  <div
                    class="tw-flex tw-mt-2"
                    :class="
                      fileName?.name ? 'tw-justify-between' : 'tw-justify-end'
                    "
                  >
                    <button
                      :disabled="!selecetdQuantity"
                      v-if="fileName?.name"
                      @click="handlePreview"
                      class="btn primarycolor"
                    >
                      Preview
                    </button>
                    <div class="button-group">
                      <button
                        v-if="step != 1"
                        @click="backStep"
                        class="navigationButton"
                      >
                        Back
                      </button>
                      <button
                        :disabled="!skuInput || !selecetdQuantity"
                        @click="nextStep"
                        class="btn primarycolor tw-mx-2"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
                <div v-if="step === 3" class="form-step">
                  <div class="tw-mb-3">SKU ID</div>
                  <multiselect
                    v-model="skuInput"
                    :options="skuList"
                    :multiple="false"
                    :searchable="true"
                    placeholder="Enter SKU ID"
                    label="product_sku"
                    track-by="product_sku"
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    disabled
                  >
                  </multiselect>
                  <label for="Quantity" class="tw-my-3">Quantity</label>
                  <input
                    v-model="selecetdQuantity"
                    id="Quantity"
                    type="number"
                    placeholder="Enter Quantity"
                    disabled
                    class="input-box tw-shadow-none tw-border-[#AEAEAE] focus:tw-border-[#AEAEAE] tw-rounded-[5px]"
                  />
                  <div
                    v-if="activeTab == 0"
                    class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1"
                  >
                    Towards
                  </div>
                  <div
                    v-else
                    class="tw-text-[#050A13] tw-text-[14px] tw-mb-3 tw-mx-1"
                  >
                    From
                  </div>
                  <multiselect
                    v-model="selectedTowards"
                    :options="warehouseList"
                    :multiple="false"
                    :searchable="true"
                    placeholder="Select Warehouse"
                    label="warehouse_name"
                    track-by="warehouse_name"
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                  >
                  </multiselect>
                  <!-- <div class="tw-text-[#505050] tw-text-[12px] tw-my-3 tw-font-[500]">
              Suggestions
            </div> -->
                  <!-- <div class="suggestions">
              <button
                v-for="(quantity, index) in quantitySuggestions"
                :key="index"
                class="sku-pill focus:tw-shadow-none focus:tw-border-[#AEAEAE]"
                @click="selectQuantitySuggestion(quantity)"
              >
                {{ quantity }}
              </button>
            </div> -->
                  <div class="button-group tw-mt-4">
                    <button
                      v-if="step != 1"
                      @click="backStep"
                      class="navigationButton"
                    >
                      Back
                    </button>
                    <button
                      v-if="activeTab == 0"
                      :disabled="!Object.keys(selectedTowards).length"
                      @click="handleSaveTransferForm('transfer')"
                      class="btn primarycolor tw-mx-2"
                    >
                      Save
                    </button>
                    <button
                      v-else
                      :disabled="!Object.keys(selectedTowards).length"
                      @click="handleSaveTransferForm('purchase')"
                      class="btn primarycolor tw-mx-2"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row card tw-border-0 tw-mx-2" v-else>
          <div>
            <div>
              <div
                class="tw-flex tw-justify-between tw-pb-2 tw-mb-4 tw-border-b-[1px] tw-border-[#D4D4D4]"
              >
                <div
                  class="tw-text-[16px] tw-text-[#065559] tw-font-[600] tw-pb-1 tw-mb-2"
                >
                  Vendor Summary
                </div>
                <button class="btn primarycolor" @click="handleDownloadTable">
                  Export
                </button>
              </div>
            </div>
            <div class="summaryContainer">
              <table id="summaryDataTable" class="tw-w-full">
                <thead>
                  <tr>
                    <th
                      v-for="(item, index) in summaryData.header"
                      :key="index"
                      class="tw-text-center"
                    >
                      <span>{{ item.label }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in summaryData.data" :key="idx">
                    <td
                      v-for="(head, index) in summaryData.header"
                      :key="index"
                    >
                      {{ item[head.key] }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <b-modal v-model="isDeleteModalOpen">
        <template #modal-title>
          <div>
            <h5 class="tw-text-[#00555A] tw-text-[16px] tw-mb-0">Confirm</h5>
          </div>
        </template>
        <div class="modal-delete-content d-flex align-items-start mb-2">
          <div
            class="delete-alert tw-text-center tw-rounded-circle tw-px-2 tw-mr-3 tw-text-[24px]"
          >
            &#9888;
          </div>
          <div class="tw-text-[#050A13] tw-text-[16px]">
            You’re about to leave this page. Any unsaved information will be
            lost. Do you want to continue
          </div>
        </div>
        <div class="tw-flex tw-justify-end">
          <b-button
            @click="
              () => {
                isDeleteModalOpen = false;
              }
            "
            class="btn primarycolor mr-2 d-flex align-items-center delete-requestBtn"
            style="background-color: var(--red)"
            >Cancel</b-button
          >
          <button
            class="btn primarycolor"
            @click="handleActiveTabChange(activeTab)"
          >
            <span>Confirm</span>
          </button>
        </div>
      </b-modal>
      <b-modal v-model="isPreviewModalOpen" size="xl">
        <template #modal-title>
          <div>
            <h5 class="tw-text-[#00555A] tw-text-[16px]">
              Review and confirm product details before finalizing.
            </h5>
            <p class="modal-desc tw-text-[14px] tw-mb-0">
              Double-check all SKUs and inventory quantities for accuracy. Make
              any necessary edits or updates before completing the upload.
            </p>
          </div>
        </template>

        <div>
          <div class="summaryContainer">
            <table id="previewTable" class="tw-w-full">
              <thead>
                <tr>
                  <th v-for="(item, index) in previewData.header" :key="index">
                    <span>{{ item.label }}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in previewData.data" :key="idx">
                  <td v-for="(head, index) in previewData.header" :key="index">
                    {{ item[head.key] }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="tw-flex tw-justify-end">
          <b-button
            @click="
              () => {
                isPreviewModalOpen = false;
              }
            "
            class="btn primarycolor px-4 py-1 mr-2 d-flex align-items-center delete-requestBtn"
            style="background-color: var(--red)"
            >Cancel</b-button
          >
          <button class="btn primarycolor" @click="handlePreviewConfirm">
            Confirm
          </button>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Multiselect from "vue-multiselect";
import Loader from "../Components/Loader.vue";
export default {
  name: "VendorSummary",
  components: { Datepicker, Multiselect, Loader },
  data: function () {
    return {
      dropownLoader: false,
      tableDataLoader: false,
      isDataPresent: true,
      isCreateForm: false,
      isDeleteModalOpen: false,
      isPreviewModalOpen: false,
      step: 1,
      skuInput: "",
      suggestions: [],
      selectedWarehouse: "",
      warehouseList: [],
      selectedSKU: "",
      skuList: [],
      selecetdQuantity: "",
      selectedTowards: "",
      summaryData: [],
      previewData: [],
      fileName: "",
      dateRange: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      formData: [
        {
          image: "Inventory_svg/Transfer-form.svg",
          activeImage: "Inventory_svg/activeTransferIcon.svg",
          title: "Transfer Form",
          heading: "Track inventory movement between locations.",
          description:
            "Keep a record of stock moving out from one warehouse or store to another.",
        },
        {
          image: "Inventory_svg/Purchase-form.svg",
          activeImage: "Inventory_svg/activePurchaseIcon.svg",
          title: "Purchase Form",
          heading: "Track inventory received from suppliers.",
          description:
            "Easily log new stock entering the warehouse through purchase orders.",
        },
      ],
      activeTab: 0,
    };
  },
  computed: {
    fileSizeInKB() {
      if (this.fileName && this.fileName.size) {
        return (this.fileName.size / 1024).toFixed(2) + " KB";
      }
      return "";
    },
  },
  mounted() {
    this.getDropdownData();
  },
  methods: {
    nextStep() {
      if (this.step < 3) this.step += 1;
    },
    backStep() {
      if (this.step > 1) this.step -= 1;
    },
    handlePreviewConfirm() {
      this.isPreviewModalOpen = false;
      this.step = 3;
    },
    setActiveTab() {
      this.isDeleteModalOpen = true;
    },
    handleEmptyValue() {
      this.skuInput = "";
      this.selecetdQuantity = "";
      this.selectedTowards = "";
      this.fileName = null;
      if (this.$refs.fileInput) {
        const input = this.$refs.fileInput;
        input.type = "";
        input.type = "file";
      }
    },
    handleCreateForm() {
      if ($.fn.DataTable.isDataTable("#summaryDataTable")) {
        $("#summaryDataTable").DataTable().destroy();
      }
      this.isCreateForm = true;
      this.activeTab = 0;
      this.step = 1;
      this.handleEmptyValue();
    },
    handleActiveTabChange() {
      this.isDeleteModalOpen = false;
      this.activeTab = this.activeTab === 0 ? 1 : 0;
      this.step = 1;
      this.handleEmptyValue();
    },
    selectSuggestion(sku) {
      this.skuInput = sku;
    },
    handleBack() {
      this.isCreateForm = false;
      this.getTableData();
    },
    handleFileSelect(event) {
      const file = event.target.files[0];
      if (file && this.isExcelFile(file)) {
        this.fileName = file;
      }
    },
    handleDrop(event) {
      const file = event.dataTransfer.files[0];
      if (file && this.isExcelFile(file)) {
        this.fileName = file;
      }
    },
    isExcelFile(file) {
      return file.name.endsWith(".xls") || file.name.endsWith(".xlsx");
    },
    handleRemoveFile() {
      this.fileName = null;
      if (this.$refs.fileInput) {
        const input = this.$refs.fileInput;
        input.type = "";
        input.type = "file";
      }
    },
    handleDownloadTable() {
      this.tableDataLoader = true;
      const url = "/api/v2/warehouse_vn/display_data";
      const payload = {
        warehouse_id: this.selectedWarehouse.warehouse,
        timestamp: this.dateRange.endDate,
        product_sku: this.selectedSKU.product_sku,
        download: true,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          window.location = res.data.data.file_url;
          this.getTableData();
          this.tableDataLoader = false;
        })
        .catch((err) => {
          console.error(err);
          this.tableDataLoader = false;
        });
    },
    handlePreview() {
      if (!this.fileName) {
        this.$bvToast.toast(`Please upload a file before previewing.`, {
          title: "Upload",
          variant: "danger",
          toaster: "b-toaster-top-center",
          autoHideDelay: 1000,
        });
        return;
      }
      this.isPreviewModalOpen = true;

      const formData = new FormData();
      formData.append("sku", this.skuInput.product_sku);
      formData.append("quantity", this.selecetdQuantity);
      formData.append("warehouse_id", this.selectedWarehouse.warehouse);
      formData.append("preview", true);
      formData.append("file", this.fileName);

      if (this.activeTab === 0) {
        formData.append("form_type", "transfer");
        formData.append("from", "");
        formData.append("towards", this.selectedWarehouse.warehouse_name);
      } else {
        formData.append("form_type", "purchase");
        formData.append("towards", "");
        formData.append("from", this.selectedWarehouse.warehouse_name);
      }

      this.$http
        .post("api/v2/vendor/inventry/upload_template", formData)
        .then((res) => {
          this.previewData = res.data;

          this.$nextTick(() => {
            setTimeout(() => {
              if ($.fn.DataTable.isDataTable("#previewTable")) {
                $("#previewTable").DataTable().destroy();
              }
              this.processPreviewTable("#previewTable");
            }, 10);
          });
        })
        .catch((err) => {
          console.error("Upload failed", err);
        });
    },

    getDropdownData() {
      if ($.fn.DataTable.isDataTable("#summaryDataTable")) {
        $("#summaryDataTable").DataTable().destroy();
      }
      this.dropownLoader = true;
      const url = "/api/v3/vn/inventory";
      this.$http
        .get(url)
        .then((res) => {
          this.warehouseList = res.data.data.warehouse;
          this.selectedWarehouse = this.warehouseList[0];
          this.skuList = res.data.data.sku;
          this.selectedSKU = this.skuList[0];
          this.suggestions = res.data.data.sku.slice(1, 6);
          this.dropownLoader = false;
          this.getTableData();
        })
        .catch((error) => {
          this.dropownLoader = false;
          console.error("Error fetching warehouse data:", error);
        });
    },
    getTableData() {
      this.tableDataLoader = true;

      if ($.fn.DataTable.isDataTable("#summaryDataTable")) {
        $("#summaryDataTable").DataTable().destroy();
      }

      const url = "/api/v2/warehouse_vn/display_data";
      const payload = {
        warehouse_id: this.selectedWarehouse.warehouse,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        product_sku: this.selectedSKU.product_sku,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.isDataPresent = res.data.data_present;
          this.summaryData = res.data.data;
          this.tableDataLoader = false;
          this.$nextTick(() => {
            this.processTable("#summaryDataTable");
          });
        })
        .catch((error) => {
          console.error("Error fetching table data:", error);
          thiis.tableDataLoader = false;
        });
    },
    handleDownloadTemplate() {
      const url = `/api/v3/vn/excel?
      warehouse_name=${this.selectedWarehouse.warehouse_name}
      &warehouse_id=${this.selectedWarehouse.warehouse}
      &warehouse_alias=${this.selectedWarehouse.warehouse_alias}`;
      this.$http
        .get(url)
        .then((res) => {
          window.location.href = res.data.data.data;
        })
        .catch((error) => {
          console.error("Error downloading template:", error);
        });
    },
    handleSaveTransferForm(warehouseType) {
      const url = "api/v2/vendor/inventry/upload_template";

      const formData = new FormData();
      formData.append("sku", this.skuInput.product_sku);
      formData.append("quantity", this.selecetdQuantity);
      formData.append("warehouse_id", this.selectedWarehouse.warehouse);
      formData.append("preview", false);
      formData.append("file", this.fileName);
      if (warehouseType == "transfer") {
        formData.append("form_type", "transfer");
        formData.append("from", "");
        formData.append("towards", this.selectedTowards.warehouse_name);
      } else {
        formData.append("form_type", "purchase");
        formData.append("towards", "");
        formData.append("from", this.selectedTowards.warehouse_name);
      }
      this.$http
        .post(url, formData)
        .then((res) => {
          this.$bvToast.toast(`Your Data has been saved.`, {
            title: "Details Saved",
            variant: "success",
            toaster: "b-toaster-top-center",
            autoHideDelay: 1000,
          });
          this.step = 1;
          this.selectedSKU = this.skuInput;
          this.selectedWarehouse = this.selectedTowards;
          this.handleEmptyValue();
          this.getTableData();
        })
        .catch((error) => {
          console.error("Error saving form:", error);
        });
    },
    processTable(id) {
      $(id).DataTable().destroy();
      $(id).DataTable({
        searching: true,
        info: true,
        ordering: true,
        order: [],
        initComplete: function () {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });
      $(id + "_filter > label").append(
        `<div class='search_icon'><img src='/Icons_SVG/Search.svg' width='20' /></div>`
      );
    },
    processPreviewTable(id) {
      $(id).DataTable().destroy();
      $(id).DataTable({
        pageLength: 5,
        lengthMenu: [5, 10],
        searching: true,
        info: true,
        ordering: true,
        order: [],
        initComplete: function () {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });
      $(id + "_filter > label").append(
        `<div class='search_icon'><img src='/Icons_SVG/Search.svg' width='20' /></div>`
      );
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.stepper-container {
  padding: 20px;
  font-family: sans-serif;
}
.steps {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.step {
  font-weight: 600;
  color: #999;
}
.step.active {
  color: #065559;
  font-weight: bold;
}
.step-circle {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border-radius: 50%;
  background-color: #a1a1a1;
  color: #fff;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.step-circle.active {
  background-color: #065559;
  color: white;
}
.line {
  flex-grow: 1;
  height: 2px;
  background-color: #ccc;
  margin: 0 10px;
}
.input-box {
  width: 100%;
  padding: 10px;
  border: 1px solid #aeaeae;
  border-radius: 5px;
  margin-bottom: 16px;
}
.suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.sku-pill {
  border: 1px solid #aeaeae;
  border-radius: 20px;
  padding: 6px 12px;
  background: white;
  cursor: pointer;
}
.button-group {
  text-align: right;
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}
.upload-container {
  border: 1px dashed #aeaeae;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s;
}
.upload-container:hover {
  border-color: #aeaeae;
}
.upload-content img {
  margin-bottom: 10px;
}
</style>
<style>
#vendorDateRange .multiselect__tags {
  border: 1px solid #ccc !important;
  max-height: 20px !important;
}
#vendorDateRange .reportrange-text {
  height: 38px !important;
  width: 180px !important;
}
#vendorDateRange .reportrange-text span {
  font-size: 16px !important;
}
</style>
